/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { Row, Col, Image, Dropdown, Menu } from "antd";
import { NavLink } from "react-router-dom";
import { downloadImageCommon, exportChatFile, currencyFormatInt } from "../../../../helpers/utilities";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";


export const ProductLocation = (props) => {
    const { title, details } = props;

    const classes = customStyles();
    const productLocation = useRef(null);
    const titleRef = useRef(null);
    const [type, setType] = useState('City');
    const [typeTitle, setTypeTitle] = useState('City');
    const [days, setDays] = useState(30);
    const mobileDevice = useMediaQuery('(min-width:1300px)');
    const [height, setHeight] = useState(300);
    const colors = [classes.greenbox, classes.orangebox, classes.bluebox];
    const border = [classes.rightgreenBorder, classes.rightorangeBorder, classes.rightblueBorder];
    const tBorder = [classes.topgreenBorder, classes.toporangeBorder, classes.topblueBorder];
    const [datas, setDatas] = useState([]);

    let cI = 0;
    const handleChange = (value) => {
        setDays(value);
        setDatas(details['topSaledCategoryBy' + type + '_' + value]);
    }

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(productLocation.current, title, type);
        }
    }

    useEffect(() => {
        if (details) {
            setDatas(details['topSaledCategoryBy' + type + '_' + days]);
        }
    }, [details]);

    const exportFile = () => {
        let newHead = [];
        exportChatFile(title, newHead);
    }

    const handleTypeChange = (value) => {
        setType(value);
        if (value === 'Pin') {
            setTypeTitle('Pincode');
        } else {
            setTypeTitle('City');
        }
        setDatas(details['topSaledCategoryBy' + value + '_' + days]);
    }

    useEffect(() => {
        let h = `calc(100% - ${titleRef.current.clientHeight - 20}px)`;
        setHeight(h);
    }, [titleRef]);

    return (
        <div ref={productLocation} className={clsx(classes.totalChartDiv)}>
            <div ref={titleRef}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span dangerouslySetInnerHTML={{ __html: title }} />
                    {
                        !mobileDevice && <br />
                    }
                    <span className={classes.lastDays}>{`Last ${days} days`}</span>
                    <span className={classes.lastDaysRadio}>
                        <RadioGroup
                            row
                            defaultValue={"30"}
                            onChange={(e) => handleChange(e.target.value)}>
                            <FormControlLabel value="30" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="30" />
                            <FormControlLabel value="120" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="120" />
                            <FormControlLabel value="300" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="300" />
                        </RadioGroup>
                    </span>
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                <div className={classes.salesByLocradiabtn}>
                    <div className={classes.totalChartDiv}>
                        <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                            <RadioGroup
                                row
                                value={type}
                                onChange={(e) => handleTypeChange(e.target.value)}>
                                <FormControlLabel value="City" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="City" />
                                <FormControlLabel value="Pin" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="Pincode" />
                            </RadioGroup>
                        </div>
                    </div>
                </div>
                <Row className={clsx(classes.salesByLochead)}>
                    <Col span={7}>
                        <p>{typeTitle}</p>
                    </Col>
                    <Col span={9}>
                        <p>Category</p>
                    </Col>
                    <Col span={3}>
                        <p>Quantity</p>
                    </Col>
                    <Col span={5} className={clsx(classes.textAlignRight)}>
                        <p>Amount</p>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.overFolwBigContent, classes.scrollBarLight)} style={{ height: height }}>
                {
                    datas && Object.keys(datas)?.length > 0 ? Object.keys(datas).map((key, index) => {
                        if (cI >= 3) {
                            cI = 0;
                        }
                        cI += 1;
                        return (
                            <Row key={index} gutter={5} type={'flex'} className={clsx(classes.salesByLocdetails)}>
                                <Col span={7}>
                                    <div className={clsx(colors[cI - 1], tBorder[cI - 1], classes.leftbox, classes.noMinHeight)}>
                                        <h6>{key}</h6>
                                    </div>
                                </Col>
                                <Col span={17}>
                                    {
                                        datas[key] && datas[key]?.map((d, di) => {
                                            let per = 100 / datas[key].length;
                                            return (
                                                <div key={`col_${di}`} className={clsx(colors[cI - 1], tBorder[cI - 1], classes.righttbox, datas[key].length)}
                                                    style={{ height: datas[key].length > 2 ? 'auto' : per + '%' }}>                                                    <Row type={'flex'}>
                                                        <Col span={13} className={clsx(border[cI - 1], classes.padding4)}>
                                                            <h6>{d?.category}</h6>
                                                        </Col>
                                                        <Col span={5} className={clsx(border[cI - 1], classes.padding4)}>
                                                            <p>{d?.quantity}</p>
                                                        </Col>
                                                        <Col span={6} className={clsx(classes.textAlignRight, classes.padding4)}>
                                                            <p>₹ {currencyFormatInt(d?.amount)}</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        })
                                    }
                                </Col>
                            </Row>
                        )
                    }) : <Row><Col span="24" className={clsx(classes.noResultsText, classes.textAlignCenter)}>Data Will be Displayed when transactions are recorded by the system</Col></Row>

                }
            </div>
        </div>
    )
}